const gifts = [
  {
    image: "/data/gifts/gift_1.png",
    title: {
      chineseTraditional: "至高真理",
      chineseSimplified: "至高真理",
      english: "The supreme truth",
      french: "La vérité suprême",
      spanish: "La verdad suprema",
      japanese: "第一義",
      korean: "궁극의 진리",
    },
    description: {
      chineseTraditional: "超越分別心的大悟境界。",
      chineseSimplified: "超越分别心的大悟境界。",
      english:
        "The state of great enlightenment that transcends discriminative thinking.",
      french:
        "L'état d'illumination suprême qui transcende la pensée discriminative.",
      spanish:
        "El estado de gran iluminación que trasciende el pensamiento discriminativo.",
      japanese: "分別心を超脱した大悟の境地",
      korean: "분별심을 초월한 위대한 깨달음의 경지.",
    },
  },
  {
    image: "/data/gifts/gift_2.png",
    title: {
      chineseTraditional: "真空",
      chineseSimplified: "真空",
      english: "The true void",
      french: "Le vrai vide",
      spanish: "El verdadero vacío",
      japanese: "真空",
      korean: "진공",
    },
    description: {
      chineseTraditional: "超越存在與非存在的分別，以及一切智性思維的境界。",
      chineseSimplified: "超越存在与非存在的分别，以及一切智性思维的境界。",
      english:
        "A state that transcends all discrimination between existence and non-existence, and all intellectual reasoning.",
      french:
        "Un état qui transcende toute distinction entre l'existence et la non-existence, ainsi que tout raisonnement intellectuel.",
      spanish:
        "Un estado que trasciende toda discriminación entre existencia y no existencia, y todo razonamiento intelectual.",
      japanese: "有無の分別、思慮すべてを超脱した境地",
      korean: "존재와 비존재의 모든 구별과 모든 지적 사고를 초월한 경지.",
    },
  },
  {
    image: "/data/gifts/gift_3.png",
    title: {
      chineseTraditional: "大雄寶殿",
      chineseSimplified: "大雄宝殿",
      english: "Daiouhouden",
      french: "Daiouhouden",
      spanish: "Daiouhouden",
      japanese: "大雄宝殿",
      korean: "대웅보전",
    },
    description: {
      chineseTraditional:
        "在日本，此名稱僅在黃檗宗中使用，指能降伏惡魔的偉大佛陀。相當於其他寺廟的佛殿。",
      chineseSimplified:
        "在日本，此名称仅在黄檗宗中使用，指能降伏恶魔的伟大佛陀。相当于其他寺庙的佛殿。",
      english:
        "In Japan, this name is used exclusively in the Obaku school. It refers to the Great Buddha who subdues demons. It corresponds to the Buddha Hall in other temples.",
      french:
        "Au Japon, ce nom est utilisé exclusivement dans l'école Ōbaku. Il se réfère au Grand Bouddha qui soumet les démons. Il correspond au Hall du Bouddha dans les autres temples.",
      spanish:
        "En Japón, este nombre se usa exclusivamente en la escuela Ōbaku. Se refiere al Gran Buda que somete a los demonios. Corresponde al Salón del Buda en otros templos.",
      japanese:
        "この名称は日本では黄檗のみで、悪魔を屈服させる大いなる仏のこと。一般寺院の仏殿に当たる。",
      korean:
        "일본에서는 황벽종에서만 사용되는 이름으로, 악마를 제압하는 위대한 부처를 의미한다. 일반 사원의 불전과 해당한다.",
    },
  },
  {
    image: "/data/gifts/gift_4.png",
    title: {
      chineseTraditional: "獅子吼",
      chineseSimplified: "狮子吼",
      english: "Lion’s Roar",
      french: "Rugissement du lion",
      spanish: "Rugido del león",
      japanese: "獅子吼",
      korean: "사자후",
    },
    description: {
      chineseTraditional:
        "佛陀的聲音被比喻為百獸之王獅子的吼聲，能壓倒一切眾生。",
      chineseSimplified:
        "佛陀的声音被比喻为百兽之王狮子的吼声，能压倒一切众生。",
      english:
        "The voice of the Buddha is likened to the roar of the lion, the king of beasts, which overpowers all beings.",
      french:
        "La voix du Bouddha est comparée au rugissement du lion, le roi des bêtes, qui domine tous les êtres.",
      spanish:
        "La voz del Buda se asemeja al rugido del león, el rey de las bestias, que domina a todos los seres.",
      japanese:
        "百獣の王ライオンの吠える声のことで何者もを屈服させる仏の声にたとえる。",
      korean:
        "부처님의 목소리를 모든 짐승의 왕인 사자의 포효에 비유하여, 모든 존재를 압도하는 소리로 묘사한다.",
    },
  },
  {
    image: "/data/gifts/gift_5.png",
    title: {
      chineseTraditional: "選佛場",
      chineseSimplified: "选佛场",
      english: "Selection Hall for Buddhas",
      french: "Salle de sélection pour les Bouddhas",
      spanish: "Sala de selección para Budas",
      japanese: " 選仏場",
      korean: "불조를 위한 선택장",
    },
    description: {
      chineseTraditional:
        "僧侶在此經受嚴格訓練與修行，並在此發掘有資格成為佛祖或祖師的人。",
      chineseSimplified:
        "僧侣在此经受严格训练与修行，并在此发现有资格成为佛祖或祖师的人。",
      english:
        "A place where monks undergo rigorous training and practice, and where those worthy of becoming Buddhas or patriarchs are found.",
      french:
        "Un lieu où les moines subissent un entraînement rigoureux et une pratique, et où ceux dignes de devenir Bouddhas ou patriarches sont trouvés.",
      spanish:
        "Un lugar donde los monjes se someten a un riguroso entrenamiento y práctica, y donde se encuentran aquellos dignos de convertirse en Budas o patriarcas.",
      japanese: "学僧を鍛錬修行させ、仏祖たるべき人を見出す場。",
      korean:
        "승려들이 엄격한 훈련을 받고 수행하며, 부처나 조사가 될 자격이 있는 사람을 찾는 장소.",
    },
  },
];

export default gifts;
